import React from 'react';
import { Users, BookOpen, Gift, Star } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <Users className="w-5 h-5 text-blue-600" data-id="element-307" />,
    text: '+1.200 personas ya se comunicaron'
  }, {
    icon: <BookOpen className="w-5 h-5 text-blue-600" data-id="element-308" />,
    text: '6 Tomos listos'
  }, {
    icon: <Gift className="w-5 h-5 text-blue-600" data-id="element-309" />,
    text: '4 Bonos incluidos'
  }, {
    icon: <Star className="w-5 h-5 text-amber-400 fill-amber-400" data-id="element-310" />,
    text: '4.9/5 calificación ⭐'
  }];
  return <div className="bg-white border-b border-slate-200 py-6" data-id="element-311">
      <div className="container mx-auto px-4" data-id="element-312">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 md:justify-between items-center max-w-5xl mx-auto" data-id="element-313">
          {stats.map((stat, i) => <div key={i} className="flex items-center gap-2 font-medium text-slate-700" data-id="element-314">
              {stat.icon}
              <span data-id="element-315">{stat.text}</span>
            </div>)}
        </div>
      </div>
    </div>;
}